<template>
  <div class="user-single">
    <PageHeader :cover="imgCoverDataUrl"></PageHeader>
    <div class="stats-bar">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-3"></div>
          <div class="col-12 col-md-9">
            <div class="stats-bar-content">
              <div class="stats-box">
                <div class="stat-box" v-b-tooltip.hover title="Vitórias / Derrotas">
                  <p class="heading">V/D</p>
                  <p class="title">{{ user.wins_count }}/{{ user.losses_count }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="Média de frags por round">
                  <p class="heading">KPR</p>
                  <p class="title">{{ user.kpr }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="Dano médio por Round">
                  <p class="heading">ADR</p>
                  <p class="title">{{ user.adr }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="Média de frags / mortes">
                  <p class="heading">KDR</p>
                  <p class="title">{{ user.kdr }}</p>
                </div>

                <div class="stat-box" v-b-tooltip.hover title="considerando as últimas 7 partidas">
                  <p class="heading">NÍVEL QUEOTA</p>
                  <p class="title">{{userLevel}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3">

          <div class="profile-avatar-container">
            <b-img class="profile-image" thumbnail rounded="circle" fluid :src="imgDataUrl" :alt="user.nickname" />
            <div class="profile-avatar-actions" v-if="user.is_current_user">
              <a class="btn" @click="avatarToggleShow" v-if="user.is_current_user">alterar avatar</a>
              <a class="btn" @click="coverToggleShow" v-if="user.is_current_user">alterar cover</a>
            </div>
            <!-- <div class="profile-avatar-badges">
              <div class="premium-badge" v-b-tooltip.hover title="usuário beta">
                <i class="fas fa-flask"></i>
              </div>
            </div> -->
          </div>


          <h1 class="user-name">{{user.nickname}}</h1>

          <div class="social-media-links">
            <a :href="user.social_facebook" v-if="user.social_facebook" target="_blank">
              <i class="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </a>
            <a :href="user.social_twitter" v-if="user.social_twitter" target="_blank">
              <i class="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a :href="user.profile_url" v-if="user.profile_url" target="_blank">
              <i class="fab fa-steam-symbol"></i>
              <span>Steam</span>
            </a>
            <a :href="user.social_instagram" v-if="user.social_instagram" target="_blank">
              <i class="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
            <a :href="user.social_twitch" v-if="user.social_twitch" target="_blank">
              <i class="fab fa-twitch"></i>
              <span>Twitch</span>
            </a>
          </div>


          <b-button block v-if="user.is_current_user" v-b-modal.modalEditUser>
            Editar perfil
          </b-button>

          <div class="profile-sidebar-box about" v-if="user.about">
            <h4>Sobre</h4>
            <p class="tagline">{{ user.about }}</p>
          </div>

          <div class="profile-sidebar-box gear" v-if="hasGear">
            <h4>Meu Setup</h4>

            <div class="gear-item" v-if="user.gear_mouse">
              <span class="gear-title">mouse</span>
              <span class="gear-text">{{ user.gear_mouse }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_pad">
              <span class="gear-title">pad</span>
              <span class="gear-text">{{ user.gear_pad }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_display">
              <span class="gear-title">display</span>
              <span class="gear-text">{{ user.gear_display }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_keyboard">
              <span class="gear-title">keyboard</span>
              <span class="gear-text">{{ user.gear_keyboard }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_phone">
              <span class="gear-title">phone</span>
              <span class="gear-text">{{ user.gear_phone }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_res">
              <span class="gear-title">res</span>
              <span class="gear-text">{{ user.gear_res }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_cpu">
              <span class="gear-title">cpu</span>
              <span class="gear-text">{{ user.gear_cpu }}</span>
            </div>

            <div class="gear-item" v-if="user.gear_vga">
              <span class="gear-title">vga</span>
              <span class="gear-text">{{ user.gear_vga }}</span>
            </div>
          </div>

          <my-upload field="img"
              v-model="avatarShow"
               v-if="user.is_current_user"
            :width="500"
            :height="500"
            langType="pt-br"
            noCircle
            @crop-success="avatarCropSuccess"
            @crop-upload-success="avatarCropUploadSuccess"
            @crop-upload-fail="avatarCropUploadFail"
            :url="avatarUploadUrl"
            :params="avatarParams"
            :headers="avatarHeaders"
            img-format="jpg">
          </my-upload>

          <my-upload field="img"
              v-model="coverShow"
               v-if="user.is_current_user"
            :width="1500"
            :height="500"
            langType="pt-br"
            noCircle
            @crop-success="coverCropSuccess"
            @crop-upload-success="coverCropUploadSuccess"
            @crop-upload-fail="coverCropUploadFail"
            :url="coverUploadUrl"
            :params="coverParams"
            :headers="coverHeaders"
            img-format="jpg">
          </my-upload>


          <b-modal id="modalEditUser" title="Editar perfil" ref="modalEditUser" @ok="handleEditOk">
            <form @submit.stop.prevent="handleEditSubmit">
              <b-form-group description="" label="Nome">
                <b-form-input v-model="user.realname"
                  type="text"
                  required
                  maxlength="40"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group description="" label="Apelido no Jogo">
                <b-form-input v-model="user.nickname"
                  type="text"
                  required
                  maxlength="25"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group description="" label="Email">
                <b-form-input v-model="user.email"
                  type="text"
                  required
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group description="" label="Telefone">
                <b-form-input v-model="user.cellphone"
                  type="text"
                  required
                  maxlength="25"
                  v-mask="['+55 ## ####-####','+55 ## #####-####']"
                  masked="true"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group description="" label="CPF">
                <b-form-input v-model="user.document_cpf"
                  type="text"
                  maxlength="15"
                  v-mask="'###.###.###-##'"
                  masked="true"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group description="" label="Sobre">
                <b-form-input v-model="user.about"
                  type="text"
                  maxlength="240"
                  placeholder="">
                </b-form-input>
              </b-form-group>
              <b-form-group label="Região dos servidores" description="recurso premium">
                <b-form-radio-group v-model="user.server_region">
                  <b-form-radio value="server_nordeste">Norte / Nordeste</b-form-radio>
                  <b-form-radio value="server_sudeste">Sul / Sudeste / Centro</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group description="" label="Facebook (link)">
                <b-form-input v-model="user.social_facebook"
                  type="url"
                  maxlength="150"
                  placeholder="https://facebook.com/USUARIO">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Twitter (link)">
                <b-form-input v-model="user.social_twitter"
                  type="url"
                  maxlength="150"
                  placeholder="https://twitter.com/USUARIO">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Instagram (link)">
                <b-form-input v-model="user.social_instagram"
                  type="url"
                  maxlength="150"
                  placeholder="https://instagram.com/USUARIO">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Twitch (link)">
                <b-form-input v-model="user.social_twitch"
                  type="url"
                  maxlength="150"
                  placeholder="https://twitch.tv/USUARIO">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Mouse">
                <b-form-input v-model="user.gear_mouse"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Mousepad">
                <b-form-input v-model="user.gear_pad"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Monitor">
                <b-form-input v-model="user.gear_display"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Teclado">
                <b-form-input v-model="user.gear_keyboard"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Fone">
                <b-form-input v-model="user.gear_phone"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Resolução">
                <b-form-input v-model="user.gear_res"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Processador/CPU">
                <b-form-input v-model="user.gear_cpu"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group description="" label="Placa de Vídeo">
                <b-form-input v-model="user.gear_vga"
                  type="text"
                  maxlength="150"
                  placeholder="">
                </b-form-input>
              </b-form-group>


            </form>
          </b-modal>

          <div class="teams-list" v-if="user.teams">
            <h4>Times</h4>
            <TeamCard :team="team" v-for="team in user.teams" :key="team.slug"></TeamCard>
          </div>

        </div>

        <div class="col-12 col-md-9">


          <div class="row">
            <div class="col-8">
              <div class="user-stats" v-if="user.ranking_history && user.ranking_history.length">
                <h5>ADR médio nas últimas 7 partidas</h5>
                <!-- area -->
                <apexchart width="100%" height="160" type="area" :options="chartOptions" :series="series"></apexchart>
              </div>
            </div>
            <div class="col-4">
              <div class="user-medals" v-if="user.ranking_history && ((user.tournaments && user.tournaments.length) || (user.clubs && user.clubs.length))">
                <h4>medalhas</h4>
                <router-link v-for="tournament in user.tournaments" :key="tournament.id" :to="{ name: 'TournamentSingle', params: { id: tournament.to_param } }"  v-b-tooltip.placement="'bottomright'" variant="primary" v-b-tooltip.hover :title="tournament.name">
                  <b-img-lazy :src="tournament.badge.thumb.url"></b-img-lazy>
                </router-link>
                <router-link v-for="club in user.clubs" :key="club.id" :to="{ name: 'ClubSingle', params: { id: club.to_param } }"  v-b-tooltip.placement="'bottomright'" variant="primary" v-b-tooltip.hover :title="club.name">
                  <b-img-lazy :src="club.badge.thumb.url"></b-img-lazy>
                </router-link>
              </div>
              <!-- <div class="user-gamification">
                <div class="gamification-box">
                  <h5 class="gamification-title">unranked</h5>
                  <span class="gamification-text">ranking QUEOTA</span>
                </div>
              </div> -->
            </div>
          </div>

          <LobbiesTable :lobbies="user.latest_lobbies" v-if="user.latest_lobbies && user.latest_lobbies.length"></LobbiesTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LobbiesTable from '@/components/LobbiesTable'
import PageHeader from '@/components/PageHeader'
import TeamCard from '@/components/TeamCard'
import myUpload from 'vue-image-crop-upload';

export default {
  name: 'UserSingle',
  computed: {
    hasGear: function() {
      var hasGear = false
      hasGear = this.user.gear_mouse ||
                this.user.gear_pad ||
                this.user.gear_display ||
                this.user.gear_keyboard ||
                this.user.gear_phone ||
                this.user.gear_res ||
                this.user.gear_cpu ||
                this.user.gear_vga
      return hasGear
    },
    userLevel: function() {
      if(this.user.ranked_level == 'level_rank_a')
        return 'A'
      else if(this.user.ranked_level == 'level_rank_b')
        return 'B'
      else if(this.user.ranked_level == 'level_rank_c')
        return 'C'
      else if(this.user.ranked_level == 'level_rank_d')
        return 'D'
      else if(this.user.ranked_level == 'level_rank_e')
        return 'E'
      else
        return '?'
    }
  },
  data () {
    return {
      user: { cover: '', id: 0, server_region: 'server_sudeste' },
      imgDataUrl: '',
      imgCoverDataUrl: '',
      avatarShow: false,
      avatarParams: {
        name: 'avatar'
			},
			avatarHeaders: {
				Authorization: localStorage.getItem('token')
      },
      avatarUploadUrl: `${window.location.hostname == 'queota.club' ? 'https://api.queota.club' : 'http://localhost:5000'}/users/${this.$route.params.id}/avatar.json`,
      coverShow: false,
      coverParams: {
        name: 'cover'
			},
			coverHeaders: {
				Authorization: localStorage.getItem('token')
      },
      coverUploadUrl: `${window.location.hostname == 'queota.club' ? 'https://api.queota.club' : 'http://localhost:5000'}/users/${this.$route.params.id}/cover.json`,
      chartOptions: {
        chart: {
          id: 'vuechart-example',
          zoom: {
            enabled: false
          }
        },
        yaxis: {
          min: 0,
          max: 140
        }
      },
      series: [{ data: [], name: 'ADR' }]
    }
  },
  metaInfo () {
    return {
      title: `${this.user.nickname}`
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('users/'+this.$route.params.id+'.json')
        .then(response => {
          this.user = response.data
          this.imgDataUrl = response.data.avatar.url
          this.imgCoverDataUrl = response.data.cover.url

          this.series[0].data = response.data.ranking_history.map(val => val.adr).reverse()

        })

        if(window.location.href.indexOf('?missingFields') > 0)
          this.$notify({
            group: 'all',
            type: 'warn',
            title: 'Para adicionar créditos, você precisa ter preenchido seu Nome, CPF e Telefone em seu cadastro.',
            duration: -1000
          })
    },

    handleEditSubmit () {
      this.$refs.modalEditUser.hide()
    },
    handleEditOk () {
      this.$http.put(`users/${this.$route.params.id}.json`, { user: this.user })
                .then(response => {
                  this.$store.dispatch('updateUserProfile', response.data)
                  this.$notify({
                    group: 'all',
                    title: 'Perfil editado com sucesso!',
                    // text: 'Hello user! This is a notification!'
                  });
                  this.$refs.modalEditUser.hide()
                })
                .catch(response => {
                  this.$refs.modalEditUser.hide()
                  // alert(JSON.stringify(response.data))
                })
    },


    avatarToggleShow() {
      this.avatarShow = !this.avatarShow;
    },
    avatarCropSuccess(imgDataUrl, field){
      this.imgDataUrl = imgDataUrl;
    },
    avatarCropUploadSuccess(jsonData, field){
      // this.imgDataUrl = jsonData.avatar.url
      this.$notify({
        group: 'all',
        title: 'Avatar alterado com sucesso',
      });
    },
    avatarCropUploadFail(status, field){
      this.imgDataUrl = this.user.avatar.url;
    },

    coverToggleShow() {
      this.coverShow = !this.coverShow;
    },
    coverCropSuccess(imgDataUrl, field){
      this.imgCoverDataUrl = imgDataUrl;
    },
    coverCropUploadSuccess(jsonData, field){
      // this.imgDataUrl = jsonData.cover.url
      this.$notify({
        group: 'all',
        title: 'Cover alterado com sucesso',
      });
    },
    coverCropUploadFail(status, field){
      this.imgCoverDataUrl = this.user.cover.url;
    },

  },
  mounted () {
    this.initialize()
  },
  watch: {
    '$route.params.id': function (id) {
      this.initialize()
    }
  },
  components: {
    PageHeader,
    'my-upload': myUpload,
    TeamCard,
    LobbiesTable
  }
}
</script>

<style lang="sass" scoped>
.user-single
  .stats-bar
    border-top: 1px solid #333
    border-bottom: 1px solid #111
    background: #333
    background: linear-gradient(0deg, rgba(49,49,49,1) 15%, rgba(29,29,29,1) 80%, rgba(17,17,17,1) 90%)
    .stats-bar-content
      padding: 10px 0
      color: white

      .stats-box
        display: flex
        // justify-content: space-between
        .stat-box
          // width: 30%
          &:not(:first-child)
            margin-left: 20px
          p
            margin: 0
            display: inline-block
            color: rgba(255, 255, 255, .8)
            &:hover
              color: rgba(255, 255, 255, 1)
          p.heading
            text-transform: uppercase
            text-align: center
            font-size: 13px
            margin-right: 5px
          p.title
            text-align: center
            font-weight: bold
            font-size: 20px

  .user-name
    word-break: break-all

  .profile-avatar-container
    position: relative
    width: 100%
    height: auto
    min-height: 255px
    margin-top: -100px
    z-index: 2
    .profile-image
      position: absolute

    .profile-avatar-actions
      display: none
    &:hover
      .profile-avatar-actions
        position: absolute
        width: 100%
        height: 100%
        background: rgba(0, 0, 0, .4)

        border-radius: 250%

        display: flex
        justify-content: center
        align-items: center

        a
          color: white
          &:hover
            text-decoration: underline

    .profile-avatar-badges
      .premium-badge
        display: flex
        justify-content: center
        align-items: center

        position: absolute
        bottom: -5px
        left: 50%
        margin-left: -17px

        color: white

        width: 34px
        height: 36px

        background: rgb(131,58,180)
        background: linear-gradient(25deg, rgba(131,58,180,.6) 25%, rgba(253,134,29,.4) 65%)

        border-radius: 4px

        opacity: .7
        transition: all .4s

        &:hover
          background: linear-gradient(25deg, rgba(131,58,180,1) 35%, rgba(253,134,29,1) 85%)
          opacity: 1
  @media (max-width: 600px)
    .profile-avatar-container
      position: relative
      margin: auto
      min-height: 360px

  .social-media-links
    margin-bottom: 20px
    display: flex
    a
      width: 32px
      height: 32px
      background: #aaa
      display: flex
      justify-content: center
      align-items: center
      border-radius: 4px
      transition: all .3s
      color: #333

      &:not(:first-child)
        margin-left: 5px

      &:hover
        text-decoration: none
        background: #333
        color: white

      span
        display: none

  .profile-sidebar-box
    margin: 30px 0
    &.gear

      .gear-item
        display: flex
        justify-content: space-between
        margin: 5px 0
        &:not(:last-child)
          border-bottom: 1px solid #ccc

        .gear-title
          text-transform: uppercase
          text-align: left
          font-size: 10px
        .gear-text
          text-align: right
          // font-weight: bold
          font-size: 12px
          word-break: break-all
          max-width: 65%


  .user-medals
    background: rgba(0, 0, 0, .04)
    padding: 10px
    margin: 5px 0
    height: 95%
    h4
      text-transform: uppercase
      text-align: left
      font-size: 13px
      margin-bottom: 0

    .no-medals
      text-align: center
      font-size: 14px
      margin-top: 70px
      color: #999


  .user-stats
    background: rgba(0, 0, 0, .04)
    padding: 10px
    margin: 5px 0
    text-align: center
    border-radius: 4px
    h5
      text-transform: uppercase
      text-align: left
      font-size: 13px
      margin-bottom: 0


.teams-list
  a
    width: 100%
    height: 110px
    border-radius: 4px
    overflow: hidden

// .members-list
//   display: flex
//   flex-wrap: wrap
//   justify-content: space-between
</style>
